
const fv_slider = new Swiper(".p_home_mv", {
  slidesPerView: 1,
  loop: true,
  centeredSlides: true,
  spaceBetween: 0,
  autoplay: {
    delay: 4000,
  },
  speed: 1000,
  loopAdditionalSlides: 3,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    768: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
  },
});
const item_slider = new Swiper(".b_itemSlider", {
  slidesPerView: 2,
  loop: true,
  centeredSlides: false,
  spaceBetween: 20,
  speed: 500,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1200: {
      slidesPerView: 3,
      spaceBetween: 60,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 60,
    },
  },
});

if (window.matchMedia('(max-width: 767px)').matches) {
  const item_slider = new Swiper(".p_item_list", {
    slidesPerView: 2,
    loop: true,
    centeredSlides: false,
    spaceBetween: 20,
    speed: 500,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
const buyer_slider = new Swiper(".b_buyerSlider", {
  slidesPerView: 1.8,
  loop: true,
  centeredSlides: true,
  spaceBetween: 30,
  speed: 500,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    1200: {
      slidesPerView: 5,
      spaceBetween: 50,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
});

const acc_ttl = Array.from(
  document.querySelectorAll(".b_category_list_item_acTtl")
);

for (let i = 0; i < acc_ttl.length; i++) {
  let ttl = acc_ttl[i];
  let content = ttl.nextElementSibling;
  ttl.addEventListener("click", () => {
    ttl.classList.toggle("is-active");
    console.log(content.style.height);
    if (content.style.height) {
      content.style.height = null;
    } else {
      content.style.height = content.scrollHeight + "px";
    }
  });
}
if (window.matchMedia('(max-width: 767px)').matches) {
gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".js-element-fast").forEach((target) => {
  gsap.fromTo(
    target,
    {
      y: -10,
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: target,
        markers: false,
        start: "-160% center",
      },
      y: 0,
      opacity: 1,
      duration: 1,
    }
  );
});
gsap.utils.toArray(".js-element").forEach((target) => {
  gsap.fromTo(
    target,
    {
      y: 20,
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: target,
        markers: false,
        start: "-100% center",
      },
      y: 0,
      opacity: 1,
      duration: 1,
    }
  );
});
}
else {
  gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".js-element-fast").forEach((target) => {
  gsap.fromTo(
    target,
    {
      y: -10,
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: target,
        markers: false,
        start: "-120% center",
      },
      y: 0,
      opacity: 1,
      duration: 1,
    }
  );
});
gsap.utils.toArray(".js-element").forEach((target) => {
  gsap.fromTo(
    target,
    {
      y: 20,
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: target,
        markers: false,
        start: "-50% center",
      },
      y: 0,
      opacity: 1,
      duration: 1,
    }
  );
});
}


const tabList = document.querySelectorAll('.p_item_tabList_item');
const tabContent = document.querySelectorAll('.p_item_tabContents');

//DOMが読み込み終わったら
document.addEventListener('DOMContentLoaded', function(){
  // タブに対してクリックイベントを適用
  for(let i = 0; i < tabList.length; i++) {
    tabList[i].addEventListener('click', tabSwitch);
  }
  // タブをクリックすると実行する関数
  function tabSwitch(){
    // activeクラスを削除
    document.querySelectorAll('.p_item_tabList_item.is-active')[0].classList.remove('is-active');
    // クリックしたタブにis-activeクラスを付与    
    // showクラスを削除
    document.querySelectorAll('.is-show')[0].classList.remove('is-show');
    // タブを配列風オブジェクトとして定義
    const aryTabs = Array.prototype.slice.call(tabList);
    // クリックしたタブの配列番号を取得     
    const index = aryTabs.indexOf(this);
    // クリックしたタブと同じ配列番号のタブコンテンツにis-showクラスを付与    
    tabContent[index].classList.add('is-show');
    this.classList.add('is-active');
  };
});

window.addEventListener('scroll', function () {
  const header = document.querySelector('.l_header');
  const fv = document.querySelector('.js-fv');
  if (window.scrollY > fv.offsetHeight) {
      header.classList.add('is-active');
  } else {
      header.classList.remove('is-active');
  }
});